
var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const FormatDate = (d) => {
    return `${d.getDate()} ${months[d.getMonth()]} ${d.getFullYear()}`;
}